import cx from 'classnames';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import { forwardRef, FunctionComponent, useRef } from 'react';

import ProductFAQ from './product-faq';
import classes from './product.module.css';

const MoreInfo: FunctionComponent<{
  productDetail: TProductDetail;
  key?: string;
}> = forwardRef(({ productDetail, key }, ref) => {
  const { t } = useTranslation();
  const infoRef = useRef<HTMLDivElement>(null);

  return (
    <div
      key={key}
      className={cx(
        'container',
        'mx-auto',
        'py-4',
        'lg:px-4',
        'grid',
        'lg:grid-cols-1',
        'gap-4'
      )}
    >
      <div
        className={cx(
          'separator-bottom',
          'lg:separator-none',
          'border-neutral-50'
        )}
      >
        <h2
          id="pp_more_info"
          ref={ref}
          className={cx(
            'flex',
            'max-md:px-4',
            'lg:px-0',
            'mb-4 scroll-mt-[316px] lg:scroll-mt-[190px]'
          )}
        >
          <span className={cx('font-bold', 'text-lg', '')}>
            {t('product:more_info')}
          </span>
        </h2>
        <p className={cx('mt-4', 'text-sm', 'max-md:px-4', 'lg:px-0')}>
          {t('product:responsabilities')}
        </p>
        <ProductFAQ
          faq={productDetail.faq}
          descriptionValues={{
            supplierName: productDetail.supplier_name,
            alvaraNumber: productDetail.permit,
          }}
        />
      </div>
      {productDetail?.long_part_description && (
        <div className={cx('max-md:px-4', 'lg:px-0')}>
          <div
            className={cx(classes.collaspible, 'overflow-hidden', 'text-sm')}
            style={{
              height: `${infoRef.current?.clientHeight}px`,
            }}
          >
            <div ref={infoRef} className={cx('leading-6')}>
              <p>{productDetail?.long_part_description}</p>

              <p className={cx('mt-4')}>
                <Trans
                  i18nKey="product:product_description.extra-info"
                  values={{
                    part: productDetail.part.name,
                    brand: productDetail.car.brand_name,
                    model: productDetail.car.model_name,
                    version: productDetail.car?.version_name || '',
                    reference: productDetail?.reference || '',
                    sku: productDetail.sku,
                  }}
                  components={{ p: <p className={cx('mb-3')} />, b: <b /> }}
                />
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

export default MoreInfo;
